import './Checkbox.css';

import { Text, TextVariant } from 'components/_temp_ui_common/theme/Text';
import { FC, InputHTMLAttributes } from 'react';
import { concatStringish } from 'utils/concatStringish';

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | React.ReactNode;
  textVariant?: TextVariant;
  testId?: string;
  checkmarkClassName?: string;
  labelStyle?: React.CSSProperties;
}

export const Checkbox: FC<CheckboxProps> = ({
  className,
  label,
  textVariant = 'body-5',
  testId,
  checkmarkClassName,
  labelStyle,
  ...rest
}) => {
  return (
    <label
      className={concatStringish('Checkbox', className)}
      data-testid={testId}
      style={labelStyle}
    >
      <input type="checkbox" {...rest} />
      <span className={concatStringish('checkmark', checkmarkClassName)}></span>
      {label && (
        <Text variant={textVariant} className="labelContent">
          {label}
        </Text>
      )}
    </label>
  );
};
